var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShareNetwork"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9781 6.87188L8.52188 10.3781M8.52188 13.6219L13.9781 17.1281M9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM19.5 18.75C19.5 20.4069 18.1569 21.75 16.5 21.75C14.8431 21.75 13.5 20.4069 13.5 18.75C13.5 17.0931 14.8431 15.75 16.5 15.75C18.1569 15.75 19.5 17.0931 19.5 18.75ZM19.5 5.25C19.5 6.90685 18.1569 8.25 16.5 8.25C14.8431 8.25 13.5 6.90685 13.5 5.25C13.5 3.59315 14.8431 2.25 16.5 2.25C18.1569 2.25 19.5 3.59315 19.5 5.25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.246aec07f1f9c3807cc2ca3529b41b19.svg";
export { ForwardRef as ReactComponent };